export default __webpack_public_path__ + "static/media/node.e71346fe.png";